const { default: Swiper } = require('swiper');
import { Scrollbar } from 'swiper/modules';

const sections = document.querySelectorAll('section.categories');

if (sections.length) {
    Swiper.use([Scrollbar]);
    sections.forEach(element => {
        const sliderElement = element.querySelector('.js-categories-slider');
        const scrollbar = element.querySelector('.slider-scrollbar');
        const isSixColumn =
            element.getAttribute('data-type') == 6 ? true : false;
        let swiper = null;

        function initSwiper() {
            if (window.innerWidth <= 991.98 && !swiper) {
                swiper = new Swiper(sliderElement, {
                    slidesPerView: isSixColumn ? 1.5 : 1.2,
                    spaceBetween: isSixColumn ? 24 : 8,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    scrollbar: {
                        el: scrollbar,
                        dragClass: 'slider-scrollbar__drag',
                        draggable: true,
                    },
                });
            } else if (window.innerWidth > 991.98 && swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }

        initSwiper();
        window.addEventListener('resize', initSwiper);
    });
}
